import { render, staticRenderFns } from "./IconResetInput.vue?vue&type=template&id=3ce37452&"
import script from "./IconResetInput.vue?vue&type=script&lang=js&"
export * from "./IconResetInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports